import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import Acompanhamento from './Acompanhamento';
import Lista from './Lista';
import NaoIniciados from './NaoIniciados';


const Index = ({ match }) => (
    <div className="content-wrapper">
        <Switch>
            {/* <Redirect exact from={`${match.url}/`} to={`${match.url}/lista`} /> */}
            <Route exact path={`${match.url}/`} component={Lista} />
            <Route path={`${match.url}/lista`} component={Lista} />
            <Route path={`${match.url}/:unidadeId/:profissionalId`} component={Acompanhamento} />
            <Route path={`${match.url}/nao-iniciados`} component={NaoIniciados} />
        </Switch>
    </div>
);

export default Index;